export default "__VITE_ASSET__3c63a984__"